import React from 'react';
import './Stats.css';
import useCountUp from '../hooks/useCountUp';
import useScrollReveal from '../hooks/useScrollReveal';

const Stat = ({ target, suffix, label, duration }) => {
  const [ref, value] = useCountUp(target, duration);
  return (
    <div className="stat" ref={ref}>
      <div className="stat-value">
        {value.toLocaleString()}
        <span className="stat-suffix">{suffix}</span>
      </div>
      <div className="stat-label">{label}</div>
    </div>
  );
};

export default function Stats() {
  const ref = useScrollReveal({ threshold: 0.3 });
  return (
    <section className="stats">
      <div className="stats-inner reveal" ref={ref}>
        <Stat target={25} suffix="+" label="Workflows automated" duration={1400} />
        <Stat target={1500} suffix="+" label="Hours given back" duration={2000} />
        <Stat target={60} suffix="%" label="Less manual effort" duration={1600} />
        <Stat target={24} suffix="/7" label="Systems running" duration={1200} />
      </div>
    </section>
  );
}
